import axios from "axios";
import { objToParams } from "@/helpers/helpers";

export default {
    async requestUserFiles({ commit }, params = {}) {
        commit('loadingUserFile');

        try {
            const response = await axios.get(`${process.env.VUE_APP_BACKEND_API}/user/files${objToParams(params)}`);
            commit('successUserFile', response.data);
            commit('resetSuccessUserFile');
            return true;
        } catch(error) {
            commit('errorUserFile', error.response.data);
            return false;
        }
    },
};
